import { checkShouldUseMocks } from '../envUtils';

export const API = {
    USER_DATA: '/ajax/me',
    URL_AUTH_SESSION_PROLONGATION: '/ajax/session/prolongation',
    LOG_OUT: '/logout',
};

if (checkShouldUseMocks({ shouldUseInTest: true })) {
    API.USER_DATA = '/api/userdata';
}

export const QUERY_KEY_USER_DATA = 'user-data';

/**
 * @name AUTH_STATUS_COOKIE_NAME
 * @name HYBRIS_SESSION_EXPIRE_COOKIE_NAME
 * cookie "isAuthorized" - set by Hybris when user is authorized with value of domain which user authorized to
 * cookie "sessionExpireTime" - set by Hybris on all Hybris requests when user is logged in. Value is timestamp value when session expires
 * To check if user is logged in in client side it should be enough to just check `isAuthorized`, but checking also `sessionExpireTime`
 * makes this decision correct all the times if for some reason `isAuthorized` is not set
 * */
export const AUTH_STATUS_COOKIE_NAME = 'isAuthorized';
export const HYBRIS_SESSION_EXPIRE_COOKIE_NAME = 'sessionExpireTime';
export const BP_ID_COOKIE_NAME = 'userAuthId';
export const USER_BROWSER_INTERACTION_THROTTLE_TIME = 30 * 1000;
export const SESSION_PROLONGATION_MODAL_BEFORE_END_TIME = 15 * 60 * 1000;
export const SESSION_PROLONGATION_MODAL_CHECK_INTERVAL = 900;
